import { encodeData, isUserLoggedIn } from '@airtel/air-utils';

import {
   isMobileApp,
   isNewIOSApp,
   getAnalyticsParams,
   makeDigitalStorePayment,
} from '@airtel-lego/native-app-bridge';

const removeBlankAttributes = (obj: Record<string, string>) => {
   const result: Record<string, string> = {};
   for (const key in obj) {
      if (obj[key]) {
         result[key] = obj[key];
      }
   }
   return result;
};

const isLocalOrTndEnv = (hostname: string) => {
   const normalizedHost = hostname.toLowerCase();
   return (
      normalizedHost.includes('localhost') ||
      normalizedHost.includes('127.0.0.1') ||
      normalizedHost.includes('tnd.airtel.com')
   );
};

const isEmbeddedInIframe = () => {
   try {
      return window.self !== window.top;
   } catch (error) {
      return true;
   }
};

export const navigateToPayment = async ({ args, onUserAction, getState }: any) => {
   const lob = 'PREPAID';
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   const siNumber = storeValues?.numberContext?.selectedNumber;
   const orderType = storeValues?.appData?.orderType;
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = storeValues?.planInfo?.planPrice;
   const referenceOrderId = storeValues?.orderData?.cartId;
   const planName = storeValues?.planInfo?.planName ?? '';
   const orderItem = storeValues?.orderData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const utm_layout = storeValues?.additionalData?.queryParams?.utm_layout || '';
   const address = storeValues?.pincodeContext?.pincodeDetails?.addressString || '';
   const price = storeValues?.planInfo?.planPrice|| '';
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId || '';
   const isApp = isMobileApp();

   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      msisdn,
      utm_source,
      price
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));

//    const queryString = Object.entries(removeBlankAttributes(urlParams))
//   .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
//   .join('&');
//   let thankYouPageUrl = `https://${window.location.hostname}/kyc/prepaid/thank-you?${queryString}`;

   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = isLocalOrTnd ? 'www.airtel.in' : hostname;

   const cancelUrl = `https://www.airtel.in/`;
   let thankYouPageUrl = `https://${redirectHost}/kyc/prepaid/thank-you?${urlSearchParams?.toString()}`;
   let linkRedirectionUrl = '';
   let redirectionUrl = `https://${redirectHost}/pay/summary?omv=v2`;

   if(hostname.includes("tnd.airtel.com")){
      thankYouPageUrl += `&pagesEnv=KONGQA&apiType=PORTFOLIO`;
      redirectionUrl += `&apiEnv=KONG178`
   }

   const encodedUrl = encodeURIComponent(encodeURIComponent(thankYouPageUrl));

   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if(isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }

   const appCheckoutPayload = createAppCheckoutPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );

    // Create web payment payload data
    const webPaymentPayload = createPaymentPayLoadForWeb(
      lob,
      msisdn, //provisionSi
      siNumber,
      cancelUrl,
      payableAmount, //totalPaymentPrice
      thankYouPageUrl,
      referenceOrderId, // COM order Id
      msisdn, // rtn
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );

   const paymentPayload = async () => {
      if (isApp) {
        const { appNumber } = (await getAnalyticsParams()) || {};
    
        if (isNewIOSApp()) {
         //TODO - appNumber will changes post payment changes are released in bridge
          if (appNumber > 964) {
            makeDigitalStorePayment(appCheckoutPayload);
            return ""
          } else {
            return webPaymentPayload
          }
        } else {
          if (appNumber > 5714) {
            makeDigitalStorePayment(appCheckoutPayload);
            return ""
          } else {
            return webPaymentPayload
          }
        }
      } else {
         return webPaymentPayload
      }
    };

    const payload = await paymentPayload();

  
   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }
   if (payload != null) {
      let url = isLocalOrTnd
         ? `https://www.airtel.in/pay/?payloadData=${payload}`
         : `https://${hostname}/pay/?payloadData=${payload}`;
      sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   } else {
      return onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  message: 'Something Went Wrong',
                  duration: 2000,
                  position: 'top',
                  toastType: 'error',
               },
            },
         ],
      });
   }
};

export const createPaymentPayLoadForWeb = (
   lob: string,
   provisionSi: string,
   siNumber: string,
   cancelUrl: string,
   price: string,
   thankYouPageUrl: string,
   orderId?: string,
   rtn?: string,
   utm_source?: string,
   utm_campaign?: string,
   utm_medium?: string,
   linkRedirectionUrl?: string,
   orderItem?: string,
   orderType?: string,
   redirectionUrl?: string,
   circleId?: string
) => {
   const paymentObj = {
      order: {
         lobName: lob,
         paymentAmount: price, // paymentAmount = packAmount - coupons
         benefitAmount: price, // benefitAmount = //same as payment amount
         requestorId: 'PREPAID_SKYC',
         requestType: 'SKYC',
         acquisitionType: 'skyc',
         scenarioType: orderType, // NEW or MNP
         serviceInstance: siNumber,
         circleId : Number(circleId)
      },
      lobData: {
         orderReferenceId: orderId,
      },
      billSummary: {
         paymentAmount: price,
         detailSection: [
            {
               key: 'Bill Payment',
               value: `₹${price}`,
            },
         ],
         transactionText: `Prepaid | ${siNumber}`,
      },
      callBack: {
         redirectionUrl: redirectionUrl,
         cancelUrl,
         linkRedirectionUrl,
      },
      resultSummary: [
         {
            heading: `Prepaid Recharge | ${siNumber}`,
            subHeading: 'Bill Payment',
            value: `₹${price}`,
         },
      ],
      result: {
         resultDetails: {
            redirectionUrlAfterResult: thankYouPageUrl,
            needToRedirectAfterResult: true, 
         },
         resultSummary: [
            {
               heading: 'SKYC Payment',
               value: `₹${price}`,
            },
         ],
      },
      flow: {
         isAuthFlow: isUserLoggedIn()
      },
   };

   return encodeData(paymentObj);
};

/**
 * Create quick checkout payload for new Android/iOS apps (DTH journey)
 * Used for app versions: iOS > 964, Android > 5714
 */
export const createAppCheckoutPayload = (
   price: string,
   thankYouPageUrlDeepLink: string,
   msisdn?: string,
   rtn?: string,
   siNumber?: string,
   referenceOrderId?: string,
   orderType?: string,
   circleId?: string
) => {
   const hostname = window.location.hostname
   let url = hostname.includes("tnd.airtel.com") ? "https://kongqa.airtel.com/preprod-178/order-service/v3/order" : "https://paydigi.airtel.in/order-service/v3/order"
   const paymentObj = {
      checkoutSdk : { totalAmount: price.toString(),
      number: siNumber,
      undiscountedAmount: price.toString(),
      subtitle: ['Prepaid skyc bill', siNumber],
      paymentLob: 'PREPAID',
      siNumber: siNumber,
      requestorName: 'SAFO',
      requesterid: 'PREPAID_SKYC',
      order: {
         request: {
            rtn: rtn,
            items: [
               {
                  orderDetailReq: {
                     lob: 'PREPAID',
                     siNumber: siNumber,
                     orderReferenceId: referenceOrderId,
                     requestType: 'SKYC',
                     scenarioType: orderType, // NEW or MNP
                     acquisitionType: 'skyc',
                     apiKeyMap: {
                        billAmount: price.toString(),
                     },
                     biller: '',
                     directPay: true,
                     packId: price.toString(),
                     circleId : Number(circleId)
                  },
               },
            ],
            journeyType: 'SKYC',
         },
         config: {
            redirectionURLOnPayment: thankYouPageUrlDeepLink,
            redirectAfterPolling: true,
            redirectionPostPayment: true,
         },
         url,
      },
   }
   };
   return JSON.stringify(paymentObj);
};

export const navigateToPaymentRevamp = async ({ args, onUserAction, getState }: any) => {

   const { storeValues } = getState();

   const lob = storeValues?.appData?.lob;
   const msisdn = storeValues?.appData?.msisdn;
   const orderType = storeValues?.appData?.connectionType;
   const siNumber = orderType.toLowerCase() == 'mnp' ? storeValues?.appData?.portingNumber : storeValues?.appData?.newMsisdn
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = lob.toLowerCase() == 'prepaid' ? storeValues?.appData?.planData?.planPrice : storeValues?.appData?.planData?.activationCharge
   const referenceOrderId = storeValues?.appData?.cartData?.cartId;
   const orderItem = storeValues?.appData?.cartData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const circleId = storeValues?.appData?.address?.circleId || '';
   const isApp = isMobileApp();
   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      lob
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));

   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = 'www.airtel.in'


   const cancelUrl = `https://www.airtel.in/`;
   let thankYouPageUrl = `https://www.airtel.in/kyc/verify?${urlSearchParams?.toString()}`;
   let linkRedirectionUrl = '';
   let redirectionUrl = `https://${redirectHost}/pay/summary?omv=v2`;

   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if (isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }


   const appCheckoutPayload = createAppCheckoutPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );

   // Create web payment payload data
   const webPaymentPayload = createPaymentPayLoadForWeb(
      lob,
      msisdn, //provisionSi
      siNumber,
      cancelUrl,
      payableAmount, //totalPaymentPrice
      thankYouPageUrl,
      referenceOrderId, // COM order Id
      msisdn, // rtn
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );


   const paymentPayload = async () => {
      if (isApp) {
         const { appNumber } = (await getAnalyticsParams()) || {};

         if (isNewIOSApp()) {
            //TODO - appNumber will changes post payment changes are released in bridge
            if (appNumber > 964) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         } else {
            if (appNumber > 5714) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         }
      } else {
         return webPaymentPayload
      }
   };

   const payload = await paymentPayload();



   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }

     let url = `https://www.airtel.in/pay/?payloadData=${payload}`


   // if (!hostname.includes("airtel.in")) {
   //    url += `&apiEnv=KONG178`
   //      redirectionUrl += `&apiEnv=KONG178`  
   // }

   if (payload != null) {
    

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   }
};



//postpaid methods for payment

export const createPaymentPostpaidPayLoadForWeb = (
   lob: string,
   provisionSi: string,
   siNumber: string,
   cancelUrl: string,
   price: string,
   thankYouPageUrl: string,
   orderId?: string,
   rtn?: string,
   utm_source?: string,
   utm_campaign?: string,
   utm_medium?: string,
   linkRedirectionUrl?: string,
   orderItem?: string,
   orderType?: string,
   redirectionUrl?: string,
   circleId?: string
) => {
   const paymentObj = {
      lobData: {},
      order: {
         lobName: 'CART_ECOM',    
         orderId: orderId, 
         serviceInstance : siNumber, 
         paymentAmount : price, 
         benefitAmount : price, 
         saveCard : false
      },
      billSummary: {
         paymentAmount: price, 
         detailSection: [
            {
               key: 'Bill Payment',
               value: `₹${price}`,
            },
         ],
         transactionText: `Postpaid | ${siNumber}`,
         primaryHeading: `Postpaid Recharge | ${siNumber}`, 
         subHeading: [ 'Bill Payment'],
      },
      callBack: {
         redirectionUrl: redirectionUrl, 
         cancelUrl, 
      },
      flow: {
         isAuthFlow: isUserLoggedIn(),
         gtmTrackingObj : {},
         showAirtelSafeBadge : true,
         trackingObj : {}
      },
      customElements: {
         notes : [ "This fee will be fully adjusted in your next bills " ],
         removeBackButton: false 
     },
      result: {
         resultDetails: {
            redirectionUrlAfterResult: thankYouPageUrl,
            needToRedirectAfterResult: true, 
         },
         resultSummary: [
            {
               heading: 'SKYC Payment',
               value: `₹${price}`,
            },
         ],
      },

   };

   return encodeData(paymentObj);
};

/**
* Create quick checkout payload for new Android/iOS apps (DTH journey)
* Used for app versions: iOS > 964, Android > 5714
*/
export const createAppCheckoutPostpaidPayload = (
   price: string,
   thankYouPageUrlDeepLink: string,
   msisdn?: string, // alt number
   rtn?: string, //logged in number
   siNumber?: string, //new slected number
   referenceOrderId?: string,
   orderType?: string,
   circleId?: string
) => {
   const paymentObj = {
      checkoutSdk : { 
      totalAmount: price.toString(),
      number: siNumber,
      undiscountedAmount: price.toString(),
      subtitle: ['Postpaid skyc bill', siNumber],
      paymentLob: 'CART_ECOM',  
      siNumber: siNumber,
      offersMeta: {
      subLob: "POSTPAID", 
      journeyType: "BookingPayment"
   },
      order: {
         request: {
            rtn: rtn
         },
         config: {
            redirectionURLOnPayment: thankYouPageUrlDeepLink,
            redirectAfterPolling: true,
            redirectionPostPayment: true,
         },
         response: {
            data: {
                orderId: referenceOrderId,
                orderAmountBreakup: {
                    totalAmount: price.toString(),
                    undiscountedAmount: price.toString(), 
                    subtitle: ["Postpaid", siNumber],
                    isGST: false, 
                    breakupInfo: [
                        {
                            type: "DEFAULT", 
                            title: "POSTPAID", 
                            value: price.toString()
                        }
                    ]
                },
                paymentDetails: {
                    communicationNumber: msisdn, 
                    loginId: rtn, 
                    serviceInstance: siNumber, 
                    orderAmount: price,  
                    undiscountedAmount: price, 
                    paymentLob: "CART_ECOM", 
                    paymentMeta: {
                        lob: "CART_ECOM", 
                        postingLobs: [], 
                        rechargeOrBill: 1 
                    }
                },
                appliedOffer: []
            }
        },
         bypassOrder: true
      },
      flow: {
         isAuthFlow: false,
         trackingObj: {
         }
     }  
   }
   };
   return JSON.stringify(paymentObj);
};

export const navigateToPaymentPostpaid = async ({ args, onUserAction, getState }: any) => {


   const { storeValues } = getState();

   const lob = storeValues?.appData?.lob;
   const msisdn = storeValues?.appData?.msisdn;
   const orderType = storeValues?.appData?.connectionType;
   const siNumber = orderType.toLowerCase() == 'mnp' ? storeValues?.appData?.portingNumber : storeValues?.appData?.newMsisdn
   const rtn = storeValues?.user?.loggedInNumber;
   const payableAmount = storeValues?.appData?.planData?.activationFee;
   const referenceOrderId = storeValues?.appData?.cartData?.cartId;
   const orderItem = storeValues?.appData?.cartData?.cartItemId ?? '';
   const utm_campaign = storeValues?.additionalData?.queryParams?.utm_campaign || '';
   const utm_medium = storeValues?.additionalData?.queryParams?.utm_medium || '';
   const circleId = storeValues?.appData?.address?.circleId || '';
   const isApp = isMobileApp();


   let params = new URLSearchParams(window.location.search);
   let utm_source = params.get('utm_source') || '';

   let urlParams: { [name: string]: string } = {
      lob
   };

   const urlSearchParams = new URLSearchParams(removeBlankAttributes(urlParams));

   const hostname = window.location.hostname;
   const isLocalOrTnd = isLocalOrTndEnv(hostname);
   const redirectHost = isLocalOrTnd ? 'www.airtel.in' : hostname;


   const cancelUrl = `https://www.airtel.in/`;
   let thankYouPageUrl = `https://${redirectHost}/kyc/verify?${urlSearchParams?.toString()}`;
   let linkRedirectionUrl = '';
   let redirectionUrl = thankYouPageUrl;


   // Create deep link URL for mobile apps
   let thankYouPageUrlDeepLink = `myairtel://webview?au=${encodeURIComponent(thankYouPageUrl)}`;
   if (isNewIOSApp()) {
      thankYouPageUrlDeepLink = `myairtel://webview?ax=${encodeURIComponent(thankYouPageUrl)}`;
   }


   const appCheckoutPayload = createAppCheckoutPostpaidPayload(
      payableAmount,
      thankYouPageUrlDeepLink,
      msisdn,
      rtn,
      siNumber,
      referenceOrderId,
      orderType,
      circleId
   );


   // Create web payment payload data
   const webPaymentPayload = createPaymentPostpaidPayLoadForWeb(
      lob,
      msisdn, 
      siNumber,
      cancelUrl,
      payableAmount, 
      thankYouPageUrl,
      referenceOrderId, 
      msisdn, 
      utm_source,
      utm_campaign,
      utm_medium,
      linkRedirectionUrl,
      orderItem,
      orderType,
      redirectionUrl,
      circleId
   );


   const paymentPayload = async () => {
      if (isApp) {
         const { appNumber } = (await getAnalyticsParams()) || {};

         if (isNewIOSApp()) {
            //TODO - appNumber will changes post payment changes are released in bridge
            if (appNumber > 964) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         } else {
            if (appNumber > 5714) {
               makeDigitalStorePayment(appCheckoutPayload);
               return ""
            } else {
               return webPaymentPayload
            }
         }
      } else {
         return webPaymentPayload
      }
   };

   const payload = await paymentPayload();


   // Web payment flow - executes for web and in app where appNumber is below configured values
   // payload === "" means makeDigitalStorePayment was called (native payment) — nothing more to do
   if (payload === "") {
      return;
   }

     let url = `https://www.airtel.in/pay/?payloadData=${payload}`


   if (!hostname.includes("airtel.in")) {
      url += `&apiEnv=KONG178`
        redirectionUrl += `&apiEnv=KONG178`  
   }


   if (payload != null) {
      // sessionStorage.setItem('paymentPayloadUrl', url);

      return onUserAction({
         actions: [
            {
               type: 'navigation',
               payload: {
                  externalUrl: url,
                  shouldAddSearchParams: false,
                  shouldOpenWindow: isEmbeddedInIframe(),
               },
            },
         ],
      });
   }
};